// import axios from 'redaxios';

// // import $ from 'jquery';
// import {formatMoney} from '@shopify/theme-currency';

// import {ellipsis} from 'ellipsed';
// import {register} from '../vendor/theme-scripts/theme-sections';
// // import {swatchSection} from '../features/swatch';
// import {tooltipSection} from '../features/tooltip';
// import {productPhotoswipeZoom} from '../features/load-photoswipe';

import {register} from '../vendor/theme-scripts/theme-sections';
import {formatMoney} from '@shopify/theme-currency';
import {modal} from '../util/modal';
import Media from '../features/media';
import accordion from '../features/accordion';
import {productAddSection} from '../features/product-add-bundle';

const sections = [];

const selectors = {
  buttonsWrapper: '[data-buttons-wrapper="bundle"]',
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',

  comparePrice: '[data-bundle-compare-price]',
  comparePriceText: '[data-bundle-compare-text]',

  priceWrapper: '[data-bundle-price-wrapper]',
  priceButton: '[data-bundle-button-price]',
  productJson: '[data-product-json]',
  productPrice: '[data-bundle-product-price]',

  priceOffWrap: '[data-bundle-price-off]',
  priceOffType: '[data-bundle-price-off-type]',
  priceOffAmount: '[data-bundle-price-off-amount]',

  bundleProductSlideshow: '[data-bundle-product-slidershow]',
}

const classes = {
  hide: 'hide',
  productPriceSale: 'product__price--sale'
}


function getProductJSON(productSection) {
  let productJSON = null;
  const productElemJSON = productSection.querySelector(`[data-product-json]`);

  if (productElemJSON) {
    return JSON.parse(productElemJSON.innerHTML);
  }
  return null;
}

class ProductBundleTemplate {
  constructor(section) {
    this.section = section;
    this.id = section.id;
    this.container = section.container;
    this.settings = section.settings;

    this.bundleState = {
      'totalCompareAtPrice': 0,
      'totalPrice': 0,
      'available': true,
      'soldOut': false,
      'onSale': false
    }

    this.priceOffWrap = this.container.querySelector(selectors.priceOffWrap);
    this.priceOffAmount = this.container.querySelector(selectors.priceOffAmount);
    this.priceOffType = this.container.querySelector(selectors.priceOffType);

    // this.addToCart = this.button = this.container.querySelectorAll(selectors.addToCart);

    // modal(this.id);
    this.media = new Media(section);
    this.bundleSlideshow = this.container.querySelector(selectors.bundleProductSlideshow);

    // const productJSON = this.container.querySelector(selectors.productJson);
    // if (productJSON && productJSON.innerHTML !== '') {
    //   this.product = JSON.parse(productJSON.innerHTML);
    // } else {
    //   console.error('Missing product JSON');
    //   return;
    // }


    this.init();
  }

  init() {
    document.addEventListener(
      'theme:variant:change',
      function(event) {
        this.sizeOptionMapping(event);
        this.pushState();
      }.bind(this)
    );

    this.bundleItemToggle();
  }

  sizeOptionMapping(event) {
    if( event.target.getAttribute(`data-bundle-item-size-mapping`) !== 'true' ) {
      return;
    }

    const sizeOptionMap = [
      ['Queen', '50x80 (1/2 Split-Queen)'],
      ['King/Cal King', '60x90 (1/2 Split-King)']
    ]
    const variant = event.detail.variant;
    console.log({
      'variant': variant
    })
    if( variant === null ) {
      return;
    }
    const selectedSizeOption = variant.option1;
    let selectedSizeArray = false;
    // console.log(`Size selected: ${selectedSizeOption}`);

    for( let i=0 ; i<sizeOptionMap.length ; i++ ) {
      let sizeArray = sizeOptionMap[i];
      if( sizeArray.indexOf(selectedSizeOption) >= 0 ) {
        selectedSizeArray = sizeArray;
        break;
      }
    }

    this.container.querySelectorAll(`[data-bundle-item-size-mapping="true"] [data-split-select-wrapper][data-option-position="1"]`).forEach((selectWrapperOption1) => {
      const selectedOption = selectWrapperOption1.querySelector(`input[type="radio"]:checked`).getAttribute('value');

      if( selectedSizeArray && selectedSizeArray.indexOf(selectedOption) == -1 ) {
        for( let i=0 ; i<selectedSizeArray.length ; i++ ) {
          const sizeNameVariation = selectedSizeArray[i];
          const radio = selectWrapperOption1.querySelector(`[type="radio"][value="${sizeNameVariation}"]`);
          if( radio !== null ) {
            radio.closest('.radio__button').querySelector('label').click();
            break;
          }
        }
      }
    });
  }

  pushState() {
    console.log('pushState');
    this.setProductState();

    let bundleState = this.bundleState
    this.updateAddToCartState(bundleState);
    this.updateProductPrices(bundleState);
    this.updateSaleTextStandard(bundleState);
    this.updateProductImage(bundleState);
  }

  setProductState() {
    this.bundleState = {
      'totalCompareAtPrice': 0,
      'totalPrice': 0,
      'available': true,
      'soldOut': false,
      'onSale': false
    }

    this.container.querySelectorAll(`[data-bundle-item-add="true"]`).forEach((productSection) => {
      const productJSON = getProductJSON(productSection);
      let variantJSON = null;

      const variantIdInput = productSection.querySelector(`[name="id"]`);
      if( variantIdInput.value === '' ) {
        this.bundleState.available = false;
        return;
      } else {
        const variantId = parseInt( variantIdInput.value );
        for( let i=0 ; i<productJSON.variants.length ; i++ ) {
          let variant = productJSON.variants[i];
          if( variant.id == variantId ) {
            variantJSON = variant;
            // console.log(variant);
            this.bundleState.totalPrice += variant.price;
            this.bundleState.totalCompareAtPrice += (variant.compare_at_price) ? variant.compare_at_price : variant.price;
            if( !variant.available ) {
              this.bundleState.soldOut = true;
            }
          }
        }
      }
    });

    // Adjust price basing on bundle discount
    const bundleDiscount = (100 - (parseInt( this.container.getAttribute(`data-discount-percentage`) ) || 0)) / 100.0;
    this.bundleState.totalPrice *= bundleDiscount;

    if( this.bundleState.totalCompareAtPrice > this.bundleState.totalPrice ) {
      this.bundleState.onSale = true;
    }
  }

  updateAddToCartState(bundleState) {
    const variant = bundleState.variant;
    let addText = theme.strings.addToCart;
    const priceWrapper = this.container.querySelectorAll(selectors.priceWrapper);
    const buttonsWrapper = this.container.querySelector(selectors.buttonsWrapper);
    const addToCart = buttonsWrapper.querySelectorAll(selectors.addToCart);
    const addToCartText = buttonsWrapper.querySelectorAll(selectors.addToCartText);


    if (priceWrapper.length && variant) {
      priceWrapper.forEach((element) => {
        element.classList.remove(classes.hide);
      });
    }

    if (addToCart.length) {
      addToCart.forEach((element) => {
        if (bundleState.available) {
          if (!bundleState.soldOut) {
            element.disabled = false;
          } else {
            element.disabled = true;
          }
        } else {
          element.disabled = true;
        }
      });
    }

    if (addToCartText.length) {
      addToCartText.forEach((element) => {
        if (bundleState.available) {
          if (!bundleState.soldOut) {
            element.innerHTML = addText;
          } else {
            element.innerHTML = theme.strings.soldOut;
          }
        } else {
          element.innerHTML = theme.strings.unavailable;
        }
      });
    }

    if (buttonsWrapper) {
      if (bundleState.available) {
        if (!bundleState.soldOut) {
          buttonsWrapper.classList.remove(classes.variantSoldOut, classes.variantUnavailable);
        } else {
          buttonsWrapper.classList.add(classes.variantSoldOut);
          buttonsWrapper.classList.remove(classes.variantUnavailable);
        }
        const formSelect = buttonsWrapper.querySelector(selectors.originalSelectorId);
        if (formSelect) {
          formSelect.value = variant.id;
        }
      } else {
        buttonsWrapper.classList.add(classes.variantUnavailable);
        buttonsWrapper.classList.remove(classes.variantSoldOut);
      }
    }
  }

  updateProductPrices(bundleState) {
    const priceWrappers = this.container.querySelectorAll(selectors.priceWrapper);
    const priceButtons = this.container.querySelectorAll(selectors.priceButton);

    priceWrappers.forEach((wrap) => {
      const comparePriceEl = wrap.querySelector(selectors.comparePrice);
      const productPriceEl = wrap.querySelector(selectors.productPrice);
      const comparePriceText = wrap.querySelector(selectors.comparePriceText);

      if (comparePriceEl) {
        if ( bundleState.onSale ) {
          comparePriceEl.classList.remove(classes.hide);
          if( comparePriceText !== null ) comparePriceText.classList.remove(classes.hide);
          productPriceEl.classList.add(classes.productPriceSale);
        } else {
          comparePriceEl.classList.add(classes.hide);
          if( comparePriceText !== null ) comparePriceText.classList.add(classes.hide);
          productPriceEl.classList.remove(classes.productPriceSale);
        }
        comparePriceEl.innerHTML = formatMoney(bundleState.totalCompareAtPrice, theme.moneyFormat);
      }
      if (productPriceEl) {
        if (bundleState.available) {
          productPriceEl.innerHTML = formatMoney(bundleState.totalPrice, theme.moneyFormat);
        } else {
          productPriceEl.innerHTML = '&nbsp;';
        }
      }
    });
  }

  updateSaleTextStandard(bundleState) {
    if (bundleState.onSale && bundleState.available) {
      let totalPriceOff = bundleState.totalCompareAtPrice - bundleState.totalPrice;
      if (!this.priceOffType) return;
      this.priceOffType.innerHTML = window.theme.strings.sale || 'sale';
      // const variant = bundleState.variant;
      if (window.theme.settings.badge_sale_type && window.theme.settings.badge_sale_type === 'percentage') {
        const discountFloat = (bundleState.totalCompareAtPrice - bundleState.totalPrice) / bundleState.totalCompareAtPrice;
        const discountInt = Math.floor(discountFloat * 100);
        this.priceOffAmount.innerHTML = `${discountInt}%`;
      } else {
        const discount = bundleState.totalCompareAtPrice - bundleState.totalPrice;
        this.priceOffAmount.innerHTML = formatMoney(discount, theme.moneyFormat);
      }
      if( this.priceOffWrap !== null ) this.priceOffWrap.classList.remove(classes.hide);
    } else {
      if( this.priceOffWrap !== null ) this.priceOffWrap.classList.add(classes.hide);
    }
  }

  hideSubproductButtons() {
    this.container.querySelectorAll(`[action="/cart/add"] [data-add-to-cart]`).forEach((button) => {
      // button.setAttribute('disabled', true);
      button.classList.add('hide');
    });
  }

  bundleItemToggle() {
    this.container.querySelectorAll(`[data-bundle-item-toggle]`).forEach((toggleInput) => {
      toggleInput.addEventListener(
        'change',
        function (evt) {
          const productSection = toggleInput.closest(`[data-section-type="product"]`);
          if( toggleInput.checked ) {
            productSection.setAttribute('data-bundle-item-add', 'true');
          } else {
            productSection.setAttribute('data-bundle-item-add', 'false');
          }
          this.pushState();
        }.bind(this)
      );
    });
  }

  // TODO:
  updateProductImage(bundleState) {
    console.log('updateProductImage')
    let variants = [];
    this.container.querySelectorAll(`[data-bundle-item-add="true"]`).forEach((productSection) => {
      const productJSON = getProductJSON(productSection);
      const variantIdInput = productSection.querySelector(`[name="id"]`);
      if( variantIdInput.value === '' ) {
        return;
      } else {
        const variantId = parseInt( variantIdInput.value );
        for( let i=0 ; i<productJSON.variants.length ; i++ ) {
          let variant = productJSON.variants[i];
          if( variant.id == variantId ) {
            variants.push(variant)
          }
        }
      }
    });

    console.log('trigger theme:bundleimage:change');

    if (this.bundleSlideshow) {
      this.bundleSlideshow.dispatchEvent(
        new CustomEvent('theme:bundleimage:change', {
          detail: {
            bundleState: bundleState,
            variants: variants
          },
        })
      );
    }

    return;
    const variant = bundleState.variant;
    if (this.slideshow && variant && variant.featured_media && variant.featured_media.id) {
      // Update variant image, if one is set
      this.slideshow.dispatchEvent(
        new CustomEvent('theme:image:change', {
          detail: {
            id: variant.featured_media.id,
          },
        })
      );
    }
  }

  _updateImage(product) {
    let $bundleItem = $(`[data-product-bundle-item][data-product-id="${product.id}"]`);
    if ( !$bundleItem.length ) {
      return;
    }

    let $bundleGroup = $bundleItem.closest(`[data-product-bundle-group]`),
        $image = $bundleGroup.find('.product-bundle__image img'),
        imgUrl = product.featured_image
                  .replace('.jpg', '_600x.jpg')
                  .replace('.png', '_600x.png')
                  .replace('.gif', '_600x.gif');
    $image
      .attr({
        'data-srcset': '',
        'class': 'lazyloaded',
        'alt': '',
        'sizes': '',
        'srcset': '',
        'data-widths': '',
        'src': imgUrl,
      })
  }
}


const productBundleSection = {
  onLoad() {
    sections[this.id] = new ProductBundleTemplate(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockDeselect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
};

register('product-bundle', [productBundleSection, productAddSection, accordion]);

